import React from 'react';
import { isValidUsername, isReservedUsername } from '../utils/reservedWords';

interface UsernameAvailabilityProps {
  username: string;
}

const UsernameAvailability: React.FC<UsernameAvailabilityProps> = ({ username }) => {
  if (!username) {
    return null;
  }

  if (!isValidUsername(username)) {
    return (
      <div className="mt-1 text-sm">
        {isReservedUsername(username) ? (
          <span className="text-red-600">
            This username is not available
          </span>
        ) : (
          <span className="text-red-600">
            Username must start with a letter and can only contain letters, numbers, underscores, and hyphens
          </span>
        )}
      </div>
    );
  }

  return (
    <div className="mt-1 text-sm text-green-600">
      Username is available
    </div>
  );
};

export default UsernameAvailability; 